module.exports = __webpack_public_path__ + "img/search-plus-light.16821c63.svg";